<div class="content content-fixed">
  <div>
    <div class="container p-2">
      <div class="mb-3 w-full page-title-box d-sm-flex items-center justify-between">
        <h3 class="font-semibold w-1/2">Index Mapping</h3>
        <div class="flex items-center justify-end space-x-2 w-1/2">
          <input
            type="text"
            placeholder="Search by BG Index Code, Flow Id" 
            [(ngModel)]="searchTerm"
            (input)="onSearchChange(searchTerm)"
            class="border p-2 w-1/2 rounded-md focus:outline-none "
          />
          <button (click)="showAddMappingForm()" class="btn border-black border flex justify-center items-center">
            <i data-feather="plus-circle" class="mr-1"></i> Add Bg Index
          </button>
        </div>
      </div>

      <div *ngIf="isAdding" class="fixed inset-0 flex items-start index justify-center bg-black bg-opacity-50">
        <div class="bg-gray-200 py-1 mt-2 rounded-lg shadow-lg w-1/2">
          <div>
            <h1 class="text-xl text-start m-2">Add New BG Index</h1>
            <p class="text-red-600">{{ errorInput }}</p>
            <div>
              <div class="bg-white p-2">
                <div *ngFor="let item of bgAdd.bgHeader; let i = index" class="flex items-center mb-2">
                  <input
                    [(ngModel)]="newMapping[bgAdd.fieldKeys[i]]"
                    [name]="bgAdd.fieldKeys[i]"
                    class="border p-2 rounded-md w-full focus:outline-none focus:ring focus:border-blue-300"
                    [placeholder]="item"
                    (change)="changingData($event)"
                  />
                </div>
              </div>
              <div class="flex justify-end mt-3 m-2 space-x-2">
                <button (click)="cancelAdd()" class="btn">Cancel</button>
                <button (click)="createMapping()" class="btn btn-primary" [disabled]="isLoading">Confirm</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--delete-->
      <div *ngIf="delete" class="fixed inset-0 flex items-center index justify-center bg-black bg-opacity-50">
        <div class="bg-white py-1 rounded-lg shadow-lg w-fit p-2">
          <h1 class="text-lg text-center">Confirm to Delete</h1>
          <p class="text-sm mt-2 text-center">Do you want to delete? Click Confirm to proceed, or Cancel to close.</p>
          <div class="flex justify-center mt-4 space-x-2">
            <button class="btn" (click)="cancelDelete()">Cancel</button>
            <button class="btn btn-primary" (click)="confirmDelete()">Confirm</button>
          </div>
        </div>
      </div>
      <!--Table-->
      <app-common-table [data]="paginatedMappings" [displayedColumns]="columns">
        <ng-template #actionButtons let-row>
          <button class="btn edit mr-2" (click)="editMapping(row)"><i class="fas fa-edit"></i></button>
          <button class="btn edit" (click)="deleteMapping(row)"><i class="fas fa-trash"></i></button>
        </ng-template>
      </app-common-table>

      <div class="flex justify-end items-center mt-4 space-x-2">
        <button
          class="btn btn-sm btn-uppercase btn-default justify-center flex items-center mx-0.5"
          (click)="goToFirstPage()"
          [disabled]="currentPage === 1"
        >
          <i class="fa fa-fast-backward"></i>
        </button>
        <button
          class="btn btn-sm btn-uppercase btn-default justify-center flex items-center mx-0.5"
          (click)="prevPage()"
          [disabled]="currentPage === 1"
        >
          <i class="fa fa-step-backward"></i>
        </button>
        <span class="text-lg">Page {{ currentPage }} of {{ totalPages }}</span>
        <button
          class="btn btn-sm btn-uppercase btn-default justify-center flex items-center mx-0.5"
          (click)="nextPage()"
          [disabled]="currentPage >= totalPages"
        >
          <i class="fa fa-step-forward"></i>
        </button>
        <button
          class="btn btn-sm btn-uppercase btn-default justify-center flex items-center mx-0.5"
          (click)="goToLastPage()"
          [disabled]="currentPage === totalPages"
        >
          <i class="fa fa-fast-forward"></i>
        </button>
      </div>

      <div *ngIf="isEditing" class="fixed inset-0 flex items-start index justify-center bg-black bg-opacity-50">
        <div class="bg-gray-200 py-1 mt-2 rounded-lg shadow-lg w-1/2">
          <h1 class="text-xl text-start m-2">Edit BG Index</h1>
          <form class="bg-white p-2">
            <div *ngFor="let key of editFields" class="mb-2 flex">
              <label class="block font-medium w-1/5">{{ getDisplayKey(key) }}</label>
              <input
                [(ngModel)]="selectedMapping[key]"
                [ngModelOptions]="{ standalone: true }"
                class="border p-2 rounded-md w-full focus:outline-none focus:ring focus:border-blue-300"
                [disabled]="getDisplayKey(key) === 'Bg Index Code'"
              />
            </div>
          </form>
          <div class="flex justify-end m-2 mt-3 space-x-2">
            <button (click)="cancelEdit()" class="btn">Cancel</button>

            <button (click)="saveMapping()" class="btn btn-primary" [disabled]="isLoading">Confirm</button>
          </div>
        </div>
      </div>

      <ng-template>
        <div *ngIf="error; else loading">
          <p class="text-red-500">{{ error }}</p>
        </div>
      </ng-template>
      <ng-template #loading>
        <p class="text-center">Loading...</p>
      </ng-template>

      <app-spinner *ngIf="isLoading" class="fixed inset-0 flex items-center justify-center"></app-spinner>
    </div>
  </div>
</div>
